import script from "./Curriculum.vue?vue&type=script&setup=true&lang=js"
export * from "./Curriculum.vue?vue&type=script&setup=true&lang=js"

import "./Curriculum.vue?vue&type=style&index=0&id=de4b7dee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de4b7dee"]])

export default __exports__